export default {"src":"/_next/static/media/question-mark.d5a43285.svg","height":44,"width":62,"blurWidth":0,"blurHeight":0};